import ConstructionIcon from "@mui/icons-material/Construction";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import { templateSystemColor } from "./TemplateSystemIcon";

const TemplateSystemChip = () => {
  const { t } = useTranslation(["glossary"]);

  return (
    <Chip
      size="small"
      icon={<ConstructionIcon />}
      label={t("glossary:template")}
      sx={{
        mx: 0.5,
        backgroundColor: templateSystemColor,
        color: "common.black",
        "& .MuiChip-icon": { color: "common.black" },
      }}
    />
  );
};

export default TemplateSystemChip;
